import { Component, effect, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../services/menu.service';
import { JobSeekerService } from 'src/app/job-seeker/job-seeker.service';

@Component({
  selector: 'app-dashboard-common',
  templateUrl: './dashboard-common.component.html',
  styleUrl: './dashboard-common.component.scss'
})
export class DashboardCommonComponent {
  @Input() menuCustom: any = [];
  @Input() role: any = "";
  public supportActive: boolean = false;
  left_menu: number = 1;
  right_body: number = 11;
  expand_menu: boolean = true;
  public openDashboard: boolean = false;
  icon: string = "fa-arrow-right";
  left_menu_display: boolean = true;
  constructor(private router: Router,
    // private http: HttpClient, 
    private menuService: MenuService,
    private jobSeekerService: JobSeekerService,
    // private utilsService:UtilsService
  ) {
    // this.updateActiveLinks();

    // this.initializeProducts();
    // this.utilsService.profileActionData.subscribe((data:any)=>{
    //   console.log("RRRRR", data)
    //   // this.profileData= data.profileData;
    //  })
    this.getMenus();

    // this.full_screen_display
    effect(() => {
      const value = this.jobSeekerService.fullScreenDisplay();

      console.log('Menu state:', value);

      if (value) {

        // this.left_menu = 0
        this.right_body = 12
        this.left_menu_display = false

      }
      else {
        this.left_menu_display = true
        this.left_menu = this.left_menu
        this.right_body = (this.left_menu == 3) ? 9 : 11

      }

      // update local variable
      // this.left_menu_display = value;
    });

    console.log("constructor", this.jobSeekerService.fullScreenDisplay())

  }
  getMenus() {
    this.menuService.getMenu.subscribe(data => {
      console.log('Menu Items:', data['VENDOR']);
      this.menuCustom = data['menu'];
    });
  }

  get full_screen_display() {
    console.log("6")
    console.log("7", this.jobSeekerService.fullScreenDisplay())

    // if (this.jobSeekerService.fullScreenDisplay()) {
    //   console.log("8", this.jobSeekerService.fullScreenDisplay())

    //   this.left_menu = 0
    //   this.right_body = 12
    //   this.left_menu_display = false
    //   this.expand_menu = true
    //   return this.jobSeekerService.fullScreenDisplay();

    // }
    // else {
    //   this.left_menu_display = true
    //   this.left_menu = 1
    //   this.right_body = 11
    //   this.expand_menu = true

    //   return this.jobSeekerService.fullScreenDisplay();
    // }
    return this.left_menu_display = this.jobSeekerService.fullScreenDisplay();

  }


  setActive(i: number, j: number) {
    this.supportActive = false;
    console.log("BBBBBBB", this.menuCustom)
    this.menuCustom.forEach((menu: any, menuIndex: number) => {

      // this.menuCustom[i].subMenu[j].active = 'active';
      menu.subMenu.forEach((subMenu: any, subMenuIndex: number) => {
        if (i == menuIndex && j == subMenuIndex) {
          this.menuCustom[i].subMenu[j].active = 'active';
        } else {
          this.menuCustom[menuIndex].subMenu[subMenuIndex].active = '';

        }


      })

      this.menuCustom[menuIndex].active = '';

      console.log("GGGGGG-" + i, this.menuCustom[i].active)
    })
    this.menuCustom[i].active = 'active';


  }

  deActive() {
    console.log("BBBBBBB", this.menuCustom)
    this.menuCustom.forEach((menu: any, menuIndex: number) => {

      // this.menuCustom[i].subMenu[j].active = 'active';
      menu.subMenu.forEach((subMenu: any, subMenuIndex: number) => {

        this.menuCustom[menuIndex].subMenu[subMenuIndex].active = '';



      })

      this.menuCustom[menuIndex].active = '';

    })


  }
  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }
  goTo(link: any) {
    this.router.navigate([link]);
    // this.updateActiveLinks();
  }

  logout() {
    this.router.navigate(['/login']);
  }
  setMenu() {
    this.expand_menu = !this.expand_menu

    console.log("1")

    if (this.expand_menu) {
      this.left_menu = 1
      this.right_body = 11
      this.icon = "fa-arrow-right"

      console.log("2")

    }
    else {
      this.left_menu = 3
      this.right_body = 9
      this.icon = "fa-arrow-left"
      console.log("3")

    }



  }

  // setFullScreen() {
  //   this.left_menu_display = !this.left_menu_display

  //   if (!this.left_menu_display) {
  //     this.left_menu = 0
  //     this.right_body = 12
  //     this.jobSeekerService.setColumnId(4)
  //     console.log("if setting")
  //   }
  //   else {
  //     this.left_menu = 1
  //     this.right_body = 11
  //     this.jobSeekerService.setColumnId(3)
  //     console.log("else setting")

  //   }
  // }

}
